"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dependencies_1 = require("../applicator/dependencies");
const def = {
    keyword: "dependentRequired",
    type: "object",
    schemaType: "object",
    error: dependencies_1.error,
    code: (cxt) => dependencies_1.validatePropertyDeps(cxt),
};
exports.default = def;
//# sourceMappingURL=dependentRequired.js.map